import { SelectEntry } from '@bpmn-io/properties-panel';

import {
  getBusinessObject,
  is,
  isAny
} from 'bpmn-js/lib/util/ModelUtil';

import {
  useService
} from '../../../hooks';

import {
  getErrorEventDefinition
} from '../../../utils/EventDefinitionUtil';

import { ListenerType, Retries } from './shared/Listener';

import ExecutionListenerHeaders from './ExecutionListenerHeaderProps';


export const EVENT_TO_LABEL = {
  'start': 'Start',
  'end': 'End',
  'cancel': 'Cancel'
};

// Specific event label for Multi instance elements: `beforeAll` runs once before MI init; `start` / `end` run per iteration.
export const MI_EVENT_TO_LABEL = {
  'beforeAll': 'Before all',
  'start': 'Before each',
  'end': 'After each'
};

export function getEventLabel(element, eventType) {
  const labels = isMultiInstance(element) ? MI_EVENT_TO_LABEL : EVENT_TO_LABEL;
  return labels[eventType];
}

export function ExecutionListenerEntries(props) {

  const {
    element,
    idPrefix,
    listener
  } = props;

  const eventTypes = getEventTypes(element);

  const entries = eventTypes.length > 1 ? [
    {
      id: idPrefix + '-eventType',
      component: EventType,
      idPrefix,
      listener,
      eventTypes
    }
  ] : [];

  entries.push({
    id: idPrefix + '-listenerType',
    component: ListenerType,
    idPrefix,
    listener
  },
  {
    id: idPrefix + '-retries',
    component: Retries,
    idPrefix,
    listener
  },
  {
    id: idPrefix + '-headers',
    component: ExecutionListenerHeaders,
    listener
  });

  return entries;
}

function EventType(props) {
  const {
    idPrefix,
    element,
    listener,
    eventTypes
  } = props;

  const modeling = useService('modeling');
  const translate = useService('translate');

  const getOptions = () => {
    return eventTypes.map(eventType => ({
      value: eventType,
      label: translate(getEventLabel(element, eventType))
    }));
  };

  const setValue = (value) => {
    modeling.updateModdleProperties(element, listener, {
      eventType: value
    });
  };

  const getValue = () => {
    return listener.get('eventType');
  };

  return SelectEntry({
    element,
    id: idPrefix + '-eventType',
    label: translate('Event type'),
    getValue,
    setValue,
    getOptions
  });
}

export function getEventTypes(element) {
  if (isAny(element, [ 'bpmn:BoundaryEvent', 'bpmn:StartEvent' ])) {
    return [ 'end' ];
  }

  if (is(element, 'bpmn:EndEvent') && getErrorEventDefinition(element)) {
    return [ 'start' ];
  }

  if (is(element, 'bpmn:Gateway')) {
    return [ 'start' ];
  }

  if (isMultiInstance(element)) {
    return [ 'beforeAll', 'start', 'end' ];
  }

  if (isAny(element, [ 'bpmn:Process', 'bpmn:Participant' ])) {
    return [ 'start', 'end', 'cancel' ];
  }

  return [ 'start', 'end' ];
}

function isMultiInstance(element) {
  const loopCharacteristics = getBusinessObject(element).get('loopCharacteristics');
  return !!loopCharacteristics && is(loopCharacteristics, 'bpmn:MultiInstanceLoopCharacteristics');
}
